import schema from './schema'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {

    grantFullAccessEntry() {
      return {
        allow_to_edit_commitments:      true,
        allow_to_edit_tasks:            true,
        allow_to_edit_tasks_details:    true,
        allow_to_see_commitment:        true,
        allow_to_see_enddates:          true,
        allow_to_see_recorded_sessions: true,
        allow_to_see_task_sessions:     true,
        allow_to_see_tasks:             true,
        allow_to_see_daily_commitments: true,
        allow_to_see_tasks_details:     true,
      }
    },

    /* getAccessTab - Returns my access rights
     *
     * Usage:
     * this.$models.goalMemberPrivacySettings.with({ goalId }).getAccessTab()
     *
     * How to check if I have access to team data?
     * access_tab[ memberId ].allow_to_*
     *
     */
    getAccessTab({ $store, $models }) {

      if ( !( 'goalId' in $store.definedProps ) ) {
        throw new Error('Please define goalId in "with".')
      }

      // TODO: What about Admin? Does admin have all access rights?
      // let privacy_settings = $models.goalMemberPrivacySettings.with({ goalId, memberId }).getList();

      const goalId = $store.definedProps[ 'goalId' ]
      const my_user_id = $models.user.defaultUserId
      const goal_members = $models.goalMember.with({ goalId }).getList();

      if ( !goal_members.$readyAll ) {
        throw new Error('Goal members not ready')
      }

      let access_tab = {};
      access_tab[ 'TEAM' ] = $models.goalMemberPrivacySettings.grantFullAccessEntry();

      for ( let memberId in goal_members.items ) {
        if ( memberId === my_user_id ) {
          access_tab[ memberId ] = $models.goalMemberPrivacySettings.grantFullAccessEntry();
        } else {
          /* INFO: Data is stored at "/goal/{goalId}/meta/members/{memberId}/privacy_settings/*" */

          let other_user_privacy_settings_towards_me =
            goal_members.items[ memberId ].privacy_settings[ my_user_id ] || {};

          let other_user_privacy_settings_towards_team =
            goal_members.items[ memberId ].privacy_settings[ 'TEAM' ] || {};

          other_user_privacy_settings_towards_me = Object.assign({},
            other_user_privacy_settings_towards_team,
            other_user_privacy_settings_towards_me
          )

          access_tab[ memberId ] = other_user_privacy_settings_towards_me;
        }
      }
      return access_tab;
    }
  },
  schema:  schema
};
